(function otherMedia(global) {
  'use strict';

  global.NewHomeSource = global.NewHomeSource || {};
  global.NewHomeSource.FullImageViewer = global.NewHomeSource.FullImageViewer || {};

  if (!global.NewHomeSource.FullImageViewerState ||
    !global.NewHomeSource.FullImageViewer.Config) {
    return;
  }

  const otherMediaType = {
    virtualWalkthrough: 'VWT',
    interactiveFloorPlan: 'IFP',
    communityVideoTour: 'SVT',
    testimonialVideo: 'CVT',
    virtualTour: 'VIR'
  };
  const tdvEvent = {
    vrtualTour: 'HDVTCT',
    interactiveFloorPlan: 'HDPVCT',
    communityVideoTour: 'CDVID',
    homeVideoTour: 'HDVID',
  };
  const previousOtherMedia = global.NewHomeSource.FullImageViewer.OtherMedia;
  const languageResources = global.NewHomeSource.FullImageViewer.Config.languageResources;
  const title = languageResources.OtherMediaTitle;
  const subtitle = languageResources.OtherMediaSubtitle;
  const captionContainer = global.document.querySelector('[data-full-image-viewer-role="caption-container"]');
  const otherMediaLogo = global.document.querySelector('[data-full-image-viewer-role="other-media-logo"]');
  const container = global.document.querySelector('[data-full-image-viewer-role="other-media"]');
  const mediaContainer = global.document.querySelector('[data-full-image-viewer-role="other-media-container"]');
  const titleElement = global.document.querySelector('[data-full-image-viewer-role="other-media-title"]');
  const otherMediaContent = global.document.querySelector('[data-full-image-viewer-role="other-media-content"]');
  const subtitleElement = global.document.querySelector('[data-full-image-viewer-role="other-media-subtitle"]');
  const swiperContainer = global.document.querySelector('[data-full-image-viewer-role="swiper-container"]');
  const isCommunityDetail = global.document.querySelector('[data-is-community]').value;
  const playerBox = global.document.querySelector(global
    .NewHomeSource.FullImageViewer.Config.queryImagesContainer);
  const dataAttributesTdv = global.NewHomeSource.FullImageViewer.Config.dataTdvAttributes;
  const getAttributeValue = global.NewHomeSource.FullImageViewer.Config.getAttributeValue;
  let tdvAttributes = '';

  for (let index = 0; index < dataAttributesTdv.length; index += 1) {
    const dataAttr = dataAttributesTdv[index];
    const value = getAttributeValue(dataAttr);
    if (value) {
      tdvAttributes += dataAttr + '="' + value + '" ';
    }
  }

  const template = '<li>' +
    '<a target="_blank" data-otherMediaType={TYPE} rel="nofollow sponsored" href="{URL}" data-event="true" ' +
    'data-segment-event="true" data-tdv-event-label="{TDVEVENT}" data-segment-event-event="Other Media Displayed"' +
    'data-segment-event-other_media_id={ID} data-segment-event-other_media_sequence={SEQUENCE} ' + tdvAttributes + '>' +
    '{TITLE} </a>' +
    '</li>';

  const logo = global.document.querySelector('[data-component="logo"]');

  if (!mediaContainer) {
    return;
  }

  if (logo) {
    otherMediaLogo.src = logo.src;
    otherMediaLogo.alt = logo.alt;
  }

  subtitleElement.innerHTML = subtitle;
  titleElement.innerHTML = title + subtitleElement.outerHTML;

  function getTdvEvent(type) {
    switch (type) {
      case otherMediaType.virtualWalkthrough:
        return tdvEvent.vrtualTour;

      case otherMediaType.virtualTour:
        return tdvEvent.vrtualTour;

      case otherMediaType.interactiveFloorPlan:
        return tdvEvent.interactiveFloorPlan;

      case otherMediaType.communityVideoTour:
        return isCommunityDetail !== 'true' ? tdvEvent.homeVideoTour : tdvEvent.communityVideoTour;

      case otherMediaType.testimonialVideo:
        return isCommunityDetail !== 'true' ? tdvEvent.homeVideoTour : tdvEvent.communityVideoTour;

      default:
    }
    return '';
  }

  function createMediaLink(link, index) {
    mediaContainer.innerHTML += template.replace('{URL}', link.url)
      .replace('{TITLE}', link.title)
      .replace('{TYPE}', link.type)
      .replace('{ID}', link.id)
      .replace('{TDVEVENT}', getTdvEvent(link.type))
      .replace('{SEQUENCE}', index + 1);
  }

  function displayInCarousel(data) {
    mediaContainer.innerHTML = '';
    data.Images[0].links.forEach(createMediaLink);
    container.style.display = 'block';
    swiperContainer.classList.add('other__media--full');
    otherMediaContent.style.display = 'block';
    captionContainer.classList.add('visuallyhidden');
  }

  /**
  * @private
  * display: attaches the other media container element to the DOM.
  *
  * @param {object} data information that is needed to render the other media links.
  */
  function display(data) {
    if (swiperContainer) {
      displayInCarousel(data);
      return;
    }

    data.Images[0].links.forEach(createMediaLink);
    container.style.display = 'block';
    playerBox.classList.add('box--full-height');
  }

  /**
  * @private
  * hide: removes the other media container element from the DOM.
  */
  function hide() {
    container.style.display = 'none';
    if (swiperContainer) {
      swiperContainer.classList.remove('other__media--full');
      otherMediaContent.style.display = 'none';
      captionContainer.classList.remove('visuallyhidden');
      return;
    }

    if (container.parentElement) {
      mediaContainer.innerHTML = '';
      playerBox.classList.remove('box--full-height');
    }
  }

  /**
   * @private
   * render: renders the mediaContainer.
   *
   * @param {object} data information that is needed to render the other media links.
   */
  function render(data) {
    if (data.Name.toLowerCase() === 'other') {
      display(data);
    } else {
      hide();
    }
  }

  /**
   * @constructs NewHomeSource.OtherMedia
   */
  function OtherMedia() {
  }

  /**
   * @public
   * update: this method will be called by the Event Bus when the data is updated.
   *
   * @param {object} data information that was changed.
   * @param {string} topic that was triggered by the Event Bus.
   */
  OtherMedia.update = function update(data, topic) {
    if (topic !== 'onCollectionSet') {
      return;
    }

    requestAnimationFrame(render.bind(this, data));
  };

  /**
   * @public
   *
   * noConflict: Returns control of NewHomeSource.OtherMedia to the previous script.
   */
  OtherMedia.noConflict = function noConflict() {
    global.NewHomeSource.FullImageViewer.OtherMedia = previousOtherMedia;
    return OtherMedia;
  };

  global.NewHomeSource.FullImageViewerState.add('onCollectionSet', OtherMedia);
  global.NewHomeSource.FullImageViewer.OtherMedia = OtherMedia;
}(window));
